import React, {useEffect, useState} from 'react';
import { useAuth } from '../../context/auth'
import { useMessage } from '../../context/message'
import MaterialTable from 'material-table'
import CustomFilter from '../CustomFilter';

export default function BidOffer(){
  const [data, setData] = useState([])
  const {auth} = useAuth()
  const { setMessage } = useMessage()

  useEffect(() => {
    fetch(`/api/bid/admin/bid_offer`, {
      method: 'GET',
      headers: {
        'x-access-token': sessionStorage.getItem('token')
      }
    })
    .then(response => auth(response))
    .then((response) => {
      setData(response.data)
    })
    .catch((error) => {
      setMessage({'type': 'error', 'text': 'Error! Unable to fetch bid offers'})
      console.error('Error:', error)
    })
  }, [])

  const columns = [
    {
      title: 'ID',
      field: 'id'
    },
    {
      title: 'Date',
      field: 'date'
    },
    {
      title: 'Product',
      field: 'product'
    },
    {
      title: 'Location',
      field: 'location'
    },
    {
      title: 'Bid/Ask',
      field: 'bid_ask'
    },
    {
      title: 'Inquiry ID',
      field: 'inquiry_id'
    },
    {
      title: 'Listing ID',
      field: 'listing_id'
    },
    {
      title: 'Trader Email',
      field: 'trader_email'
    },
    {
      title: 'Terminal Email',
      field: 'terminal_email'
    }
  ]

  return(
    <MaterialTable
      title = 'Bid Offers'
      columns = {columns}
      data = {data}
      options = {{
        filtering : true,
        draggable : false
      }}
      components={{
        FilterRow: props => <CustomFilter {...props} />,
      }}
    />
  )
}
